import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import API from "../../Network/API";
import PostLoader from '../../assets/loader.gif';
import UserAvatar from "../../components/UserAvatar";

export default function EnrollmentCourseDetails() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [data, setData] = useState()
    const prams = useParams();
    const [isLoading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true)
        API.get(`/v1/oauth/teacher/order-details/${prams?.id}`)
            .then((response) => {
                setData(response.data.data)
                setLoading(false)
            }).catch((error) => {
                setLoading(false)
            });

    }, [prams?.id]);

    const amount = Number(data?.course?.payment_info?.amount ?? 0);

    return (
        <>
            {isLoading ?
                <div className='content' style={{ margin: 'auto', padding: 'auto', textAlign: 'center', height: '500px' }}>
                    <img src={PostLoader} alt={t("enrollmentCourseDetails.loading")} height={80} width={80} />
                </div>
                :
                <>
                    <div className="dashboard-title d-flex align-items-center">
                        <Link to={`/dashboard/all-enrollment-courses`} className="back-circle-btn me-3" title={t("enrollmentCourseDetails.back_to_classes")}>
                            <i className="fa-light fa-arrow-left" />
                        </Link>
                        <h4 className="mb-0">{t("enrollmentCourseDetails.order_details")}</h4>
                    </div>

                    <div className="row">
                        <div className="col-lg-7 mb-3">
                            <div className="dash-card h-100">
                                <p className="order-detail-label">{t("enrollmentCourseDetails.course")}</p>
                                <div className="d-flex order-detail-course">
                                    <img
                                        className="order-detail-cover flex-shrink-0"
                                        src={data?.course?.cover_image || '/assets/img/no_image.jpg'}
                                        alt={data?.course?.course_title || t("enrollmentCourseDetails.course_cover")}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = '/assets/img/no_image.jpg';
                                        }}
                                    />
                                    <div className="ms-3 min-w-0">
                                        <span className={`status-badge ${data?.course?.course_type == 'recorded' ? 'muted' : 'ok'}`}>
                                            {data?.course?.course_type == 'recorded' ? t("enrollmentCourseDetails.recorded") : t("enrollmentCourseDetails.live")}
                                        </span>
                                        <h5 className="order-detail-title mt-2 mb-1">{data?.course?.course_title}</h5>
                                        {data?.course?.lesson_name &&
                                            <p className="order-detail-lesson mb-1"><i className="fa-light fa-book-open me-2" />{data?.course?.lesson_name}</p>
                                        }
                                        <p className="order-detail-price mb-0">{amount > 0 ? `$${amount.toFixed(2)}` : t("enrollmentCourseDetails.free")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 mb-3">
                            <div className="dash-card h-100">
                                <p className="order-detail-label">{t("enrollmentCourseDetails.student")}</p>
                                <div className="d-flex align-items-center">
                                    <UserAvatar src={data?.course?.student_image} name={data?.course?.student_name} size={56} />
                                    <div className="ms-3 min-w-0">
                                        <h6 className="order-detail-title mb-0">{data?.course?.student_name}</h6>
                                        <p className="order-detail-lesson mb-0">{data?.course?.student_email}</p>
                                    </div>
                                </div>
                                <Link to={`/dashboard/chat/conversation/${data?.course?.student_id}`} className="row-action-btn primary mt-3">
                                    <i className="fa-light fa-message-lines" />{t("enrollmentCourseDetails.message_student")}
                                </Link>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="dashboard-title">
                                <h4>{t("enrollmentCourseDetails.earning_details")}</h4>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="table-responsive custom-table">
                                <table className="table table-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>{t("enrollmentCourseDetails.order_date")}</th>
                                            <th>{t("enrollmentCourseDetails.title")}</th>
                                            <th>{t("enrollmentCourseDetails.amount")}</th>
                                            <th>{t("enrollmentCourseDetails.fee")}</th>
                                            <th>{t("enrollmentCourseDetails.clearance")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td data-label={t("enrollmentCourseDetails.order_date")}>{data?.course?.created_at}</td>
                                            <td data-label={t("enrollmentCourseDetails.title")}>{data?.course?.lesson_name || data?.course?.course_title}</td>
                                            <td data-label={t("enrollmentCourseDetails.amount")}>${amount.toFixed(2)}</td>
                                            <td data-label={t("enrollmentCourseDetails.fee")}>{data?.earning_info?.fees != null ? `$${Number(data?.earning_info?.fees).toFixed(2)}` : '—'}</td>
                                            <td data-label={t("enrollmentCourseDetails.clearance")}>
                                                {data?.earning_info?.approved == '1' ?
                                                    <span className="status-badge ok">{t("enrollmentCourseDetails.approved")}</span>
                                                    :
                                                    <span className="status-badge pending">{t("enrollmentCourseDetails.pending")}</span>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </>
            }
        </>
    )
}
